import { createContext } from 'react'
import { Campaign, CustomAttribute, GraphRoot, MathExpression } from '@/api/dashboard'
import { Viewport } from 'reactflow'
import { NodeAnalytics } from '@/layouts/campaigns/types'
import { CampaignEditorMode } from '@/expr/types'

export interface ICampaignContext {
  campaign: Campaign
  playerCustomAttributes: CustomAttribute[]
  graph: GraphRoot
  historyMode?: boolean
  readOnly?: boolean
  segmentGroupId?: string
  mode?: CampaignEditorMode
  viewPort?: Viewport | undefined
  nodeAnalytics?: NodeAnalytics
  onChangeVariable?: (expression: MathExpression) => void
  onChangeVariables?: (vars: MathExpression[]) => void
}

export const CampaignContext = createContext<ICampaignContext | null>(null)
